<script>
import { mapState, mapActions } from 'vuex';
/* components */
import SvgIcon from '@/components/SvgIcon';
import Avatar from '@/components/Avatar';
/* tools */
import { applyLanguage } from '@/scripts/language';
import { flagNameFromCountry } from '@/scripts/utils';
/* import { getGames } from '@/scripts/api/games'; */

export default {
  name: 'User',
  components: {
    SvgIcon,
    Avatar,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    score: {
      type: Object,
      default: () => ({}),
    },
    inSettings: {
      type: Boolean,
      default: false,
    },
    currentGameIsConnected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {
    user() {},
  },
  computed: {
    ...mapState([]),

    flagName() {
      const { country } = this.user;
      const result = flagNameFromCountry(country);

      return result;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({
      setUser: 'setUser',
      setGames: 'setGames',
    }),
    applyLanguage,
  },
};
</script>

<template>
  <div class="user">
    <!--  -->
    <div class="user__img">
      <Avatar :editable="!!inSettings" />
    </div>

    <!-- content -->
    <div
      :class="{
        user__content: true,
        'user__content--remove-avatar': !!inSettings,
      }"
    >
      <div class="user__name">{{ user.firstName }} {{ user.lastName }}</div>
      <div class="user__country">
        <div class="user__flag">
          <SvgIcon :name="flagName"></SvgIcon>
        </div>
        <span>{{ user.country }}</span>
      </div>

      <!-- hide level and connection -->
      <div class="user__between" v-show="!inSettings">
        <div v-if="score" class="user__level">
          level <span>{{ score.currentLevel }}</span>
        </div>

        <!-- > -->
        <!-- TODO: del -->
        <!-- <div
          :class="{ user__connected: true, connected: currentGameIsConnected }"
        >
          <span>
            {{ applyLanguage('connected') }}
          </span>
          <div
            class="user__try"
            v-show="!currentGameIsConnected"
            @click="againConnect"
          >
            Please Try Again
          </div>
        </div> -->
        <!-- < -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.user {
  display: flex;
  width: 100%;

  &__img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    border-radius: 12px;
    background-color: rgba(16, 18, 18, 0.5);
    flex-shrink: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  &__content {
    margin-left: 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-family: Poppins-Regular;
    font-size: 18px;
    line-height: 25px;
    color: #ffffff;
  }

  &__country {
    display: flex;
    align-items: center;
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 10px;
    text-transform: uppercase;

    .avatar__falg {
      margin-right: 5px;
    }
  }

  &__flag {
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 5px;

    .svg-icon {
      position: relative;
      width: 12px;
      height: 12px;
      transform: scale(1.4);
    }
  }

  &__between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 24px;
  }

  &__level {
    font-family: Poppins-Bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.29px;
    color: #ffc800;
    text-transform: capitalize;
  }

  /* TODO: del */
  &__connected {
    font-family: Poppins-Regular;
    font-size: 10px;
    line-height: 15px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    padding-left: 10px;
    position: relative;
    text-transform: uppercase;

    &:before {
      content: '';
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: currentColor;
    }

    &.connected {
      color: #38d5b8;
    }

    &:not(.connected) {
      color: #e93c5c;
    }
  }

  &__try {
    text-decoration: underline;
    padding: 0 5px;
    cursor: pointer;
    transition: all 0.2s;
    text-transform: capitalize;
    &:hover {
      opacity: 0.7;
    }
  }
}

@media (max-width: $mobile) {
  .user {
    &__name {
      font-size: 16px;
      line-height: 23px;
    }

    &__content {
      &.user__content--remove-avatar {
        padding-bottom: 25px;
      }
    }

    &.user-profile {
      .user {
        &__img {
          width: 60px;
          height: 60px;
          border-radius: 16px;
        }

        &__content {
          margin-left: 10px;
          position: relative;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: flex-start;
        }

        &__name {
          width: 100%;
          padding: 4px 35px 0 0;
        }

        &__between {
          margin-top: 10px;
          width: auto;
        }

        &__connected {
          margin-left: 0;
          line-height: 17px;
        }

        &__country {
          margin-right: 5px;
        }

        &__level {
          position: absolute;
          top: 0;
          right: 0;
          font-size: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #171430;

          span {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
